module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-body"
  }, [_c('div', {
    staticClass: "c-body__title"
  }, [_c('h2', [_vm._v("このサイトについて")])]), _vm._v(" "), _c('div', {
    staticClass: "c-body__inner"
  }, [_c('div', {
    staticClass: "e-grid -triple"
  }, [_c('div', {
    staticClass: "col -double"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('h3', [_vm._v("Codogue [コドーグ]")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\tこのサイトは、わざわざ自作する程でもないちょこざいな小道具の置き場です。\n\t\t\t\t\t\t作者が欲しいなと思った物を作っては出し、作っては出し、時には葬ったりしています。\n\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t実験室を兼ねているので、不具合もあるかもしれません。\n\t\t\t\t\t\tそんな時は、気兼ねなく作者まで連絡を飛ばしてください。\n\t\t\t\t\t")])]), _vm._v(" "), _c('hr', {
    staticClass: "e-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('h3', [_vm._v("推奨環境")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t各ブラウザの最新バージョンでご利用ください。\n\t\t\t\t\t\tレガシーな環境での動作保証はいたしかねます。\n\t\t\t\t\t")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Chrome 最新版")]), _vm._v(" "), _c('li', [_vm._v("Firefox 最新版")]), _vm._v(" "), _c('li', [_vm._v("Edge / IE 11+")])])]), _vm._v(" "), _c('hr', {
    staticClass: "e-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "e-section"
  }, [_c('h3', [_vm._v("免責事項")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("本サイトのツールを使用するにあたって如何なるアクシデントや障害が生じたとしても、 当方は一切の責任を負うことは出来ません。")]), _vm._v(" "), _c('li', [_vm._v("ツール・ならびにサイトの内容は予告なしに変更が加えられる事があります。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "e-section"
  }, [_c('h3', [_vm._v("連絡先")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/codogue"
    }
  }, [_vm._v("@codogue")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/mach3ss"
    }
  }, [_vm._v("@mach3ss")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4163f767","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/page/about.vue
// module id = 61
// module chunks = 0